import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Что-то пошло не так!',
  subtitle: 'Попробуйте оставить заявку позже',
} as const satisfies TMessages
